import { createContext, useContext } from 'react';

import { CodeLanguageType } from '@/components/Code/types';

export const LanguageContext = createContext<
  | {
      language: CodeLanguageType;
      setLanguage: (value: CodeLanguageType) => void;
    }
  | undefined
>(undefined);

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return [context.language, context.setLanguage] as const;
};
